import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import BookingForm from "@/components/BookingForm";

export default function BookingDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="booking-dialog" className="bg-[#121315] border border-[#8C7355]/25 text-[#F5F4F0] sm:max-w-xl p-8 md:p-10">
        <DialogHeader>
          <p className="text-[#C9A876] text-[10px] tracking-[0.4em] uppercase">Private Consultation</p>
          <DialogTitle className="font-serif-display font-light tracking-tight text-3xl md:text-4xl text-[#F5F4F0]">Request an appointment</DialogTitle>
          <DialogDescription className="text-[#D6D1CA]/55 font-body">
            184 Victoria Road, Drummoyne — Mon–Fri 9:00am – 5:00pm. Saturday by appointment. Closed Sundays.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <BookingForm onDone={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
